import { render, staticRenderFns } from "./Newsale.vue?vue&type=template&id=06cdce3c&scoped=true&"
import script from "./Newsale.vue?vue&type=script&lang=js&"
export * from "./Newsale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cdce3c",
  null
  
)

export default component.exports